/* eslint-disable*/
import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Backdrop from "@mui/material/Backdrop";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CheckIcon from "@mui/icons-material/Check";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { Box, Button, CircularProgress } from "@mui/material";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import {
  AccountAPI,
  PerformanceBondAPI,
  RequestFormAPI,
  SharePointFolder,
} from "../services/apigateway";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import RequiredUploadDocuments from "../components/PerformanceBond/RequiredUploadDocuments";
import dayjs from "dayjs";
import helper from "../services/helper";
import { useLocation } from "react-router-dom";
import ModalPerformanceBondForm from "../components/PerformanceBond/Modal/ModalPerformanceBondForm";

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  fontWeight: "bold",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
  }),
}));

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 5,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

function ColorlibStepIcon(props) {
  let { completed } = props;

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed }}
      style={{
        color: "white",
        backgroundColor: "rgba(184,0,200,1)",
        border: "1px solid #b5b5b5",
      }}
    >
      {completed ? <CheckIcon /> : <>{props.icon}</>}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

export default function PerformanceBondReviewScreen() {
  const { id } = useParams();
  const location = useLocation();
  const financialInfo = location.state?.item || null;
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState(false);
  const [objChangeMasterFile, setObjChangeMasterFile] = React.useState({});
  const [isEdited, setIsEdited] = React.useState(false);
  const [openModalComplete, setOpenModalComplete] = React.useState(false);
  const [companyName, setCompanyName] = React.useState("");
  const [pathsSharePoint, setPathsSharePoint] = React.useState([]);
  const [formHeader, setFormHeader] = React.useState([]);
  const [defaultPerformanceBond, setDefaultPerformanceBond] = React.useState([]);

  const [selectedOther, setSelectedOther] = React.useState([]);
  const [validateFields, setValidateFields] = React.useState(false);
  const [requestId, setRequestId] = React.useState("");
  const [isRequestValid, setIsRequestValid] = React.useState(false);

  React.useEffect(() => {
    setOpenModalComplete(false);
    const element = document.querySelector(".MuiStepLabel-iconContainer");
    if (element) {
      const elementText = document.querySelector(".css-1am1g1a");
      if (elementText) {
        elementText.textContent = "3";
      }
    }

    // Call your RequestForm function here
    const fetchData = async () => {
      try {
        setLoading(true);
        const requestsAll = await RequestFormAPI.findAll();

        let reschecks = requestsAll.find((item) => item.CustomerId === financialInfo.AccountId
          && item.RecordTypeName === "Performance Bond"
          && item.Status !== "Completed" && item.Status !== "End Process")

        setIsRequestValid(reschecks);

        if (reschecks) {
          Swal.fire({
            icon: 'warning',
            title: 'Please Notice',
            html: `You cannot create this request.<br/>
                  Please contact the trader team via<br/>
                  <strong>topgroupcmcs@thaioilgroup.com</strong>`,
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6',
            showCancelButton: false,
            showDenyButton: false,
            position: 'center'
          }).then(async (result) => {
            if (result.isConfirmed) {
              navigate("/main")
            }
          })
          setLoading(false);
        }

        if (id) {
          const accountMenu = helper.Auth.getAccountMenu();
          const accountInfo = await AccountAPI.findAll();
          setDefaultPerformanceBond(accountMenu.accountFinancialInfo[0].PerformanceBond__c);
          const findAccount = accountInfo.find(
            (item) =>
              item.CustomerId === accountMenu.accountFinancialInfo[0].AccountId
          );
          setFormHeader(findAccount || null);

          const response = await SharePointFolder.getPathByAccount(
            accountMenu.accountFinancialInfo[0].AccountId || ""
          );


          const filesSharePoint = response.responseData;

          let company = accountMenu.accountFinancialInfo.find(
            (item) => item.Id === id
          );
          if (company) {
            setCompanyName(company.Name);
          }

          const mappedFiles = {
            Account_Common_CTR_Others: [],
          };

          filesSharePoint.forEach((folder) => {
            if (mappedFiles.hasOwnProperty(folder.Name)) {
              mappedFiles[folder.Name] = folder.Path || [];
            }
          });

          setPathsSharePoint(mappedFiles);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchData();
  }, [id]);

  const uploadFileToSharepoint = async (file, namefolder) => {
    const accountMenu = helper.Auth.getAccountMenu();

    try {
      if (file && namefolder) {
        const uploadResponse = await SharePointFolder.uploadFile(
          namefolder,
          [file],
          accountMenu.accountFinancialInfo[0].AccountId || ""
        );
        console.log("Upload SP financial res:", uploadResponse);
      }
    } catch (error) {
      console.error("Error while uploading:", error);
      if (error.response) {
        console.error("Response:", error.response);
      }
      Swal.fire({
        title: "Error while uploading:" + error,
        icon: "error",
        position: "center",
      });
    }
  };

  const updateFiles = async () => {
    try {
      const userInfo = helper.Auth.getTokenData();
      const accountMenu = helper.Auth.getAccountMenu();

      const fileInputs = [
        { id: "FileOther2", path: pathsSharePoint.Account_Common_CTR_Others },
      ];

      // Function to rename and upload files
      const processFiles = async (fileInput) => {
        const fileElement = document.getElementById(fileInput.id);

        if (!fileElement || fileElement.files.length === 0) return [];

        const uploads = Array.from(fileElement.files).map(async (file) => {
          const timestamp = dayjs().format("YYYYMMDD_HHmmss");
          const renamedFile = new File(
            [file],
            `${file.name.replace(/\.[^/.]+$/, "")}_${timestamp}.${file.name
              .split(".")
              .pop()}`,
            { type: file.type }
          );

          await uploadFileToSharepoint(renamedFile, fileInput.path);
          return {
            name: renamedFile.name,
            type: fileInput.path.split(".").pop(),
          };
        });

        return Promise.all(uploads);
      };

      // Process all file inputs and Upload summary to Salesforce ##__ChangeMasterFiles__##
      const allFilesExist = await checkFilesExist();

      const masterFileList = (
        await Promise.all(fileInputs.map(processFiles))
      ).flat();

      if (allFilesExist) {
        if (masterFileList.length > 0) {

          // let company = accountMenu.accountFinancialInfo.find(
          //   (item) => item.Id === id
          // );

          formHeader.CTRUser = userInfo.id
          formHeader.PerformanceBondHeader =
            financialInfo?.PerformanceBond || "";
          formHeader.PerformanceBondItem =
            objChangeMasterFile?.RequestFormItem.PerformanceBondItem || "";
          formHeader.Remark = objChangeMasterFile?.RequestFormItem.Remark || "";
          formHeader.AccountId =
            accountMenu.accountFinancialInfo[0].AccountId || "";
          formHeader.FinancialInformationId =
            accountMenu.accountFinancialInfo[0].Id || "";

          // console.log('formHeader >> ', JSON.stringify(formHeader));

          let resPerfomance = await PerformanceBondAPI.submitRequestForm(
            formHeader
          );
          console.log("response create perfomance bond :: ", resPerfomance);
          setRequestId(resPerfomance && resPerfomance.RegistrationNumber);

          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }

      // Clear input values
      return true;
    } catch (error) {
      console.error("Error in handling file upload:", error);
      return false;
    }
  };

  const checkFilesExist = async () => {
    const fileInputs = [{ id: "FileOther2", label: "FileOther2" }];
    let filesExist = [];
    fileInputs.forEach((input) => {
      const fileInputElement = document.getElementById(input.id);
      if (fileInputElement.files.length > 0) {
        Array.from(fileInputElement.files).forEach((file) =>
          filesExist.push(file.name)
        );
      }
    });

    return filesExist.length > 0;
  };

  const handleSubmitFiles = async function () {
    try {
      if (objChangeMasterFile.RequestFormItem?.PerformanceBondItem !== "" &&
        objChangeMasterFile.RequestFormItem?.PerformanceBondItem !== null &&
        objChangeMasterFile.RequestFormItem?.PerformanceBondItem !== undefined) {

        setValidateFields(false)
        Swal.fire({
          title: "Are you sure you want to save?",
          icon: "question",
          position: "center",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "Yes",
          cancelButtonColor: "red",
        }).then(async (result) => {
          if (result.isConfirmed) {
            setLoading(true);
            let resChecks = await updateFiles(); // อัพโหลดไฟล์ไปยัง SharePoint and create performance bond
            if (resChecks) {
              setLoading(false);
              setOpenModalComplete(true);
              document
                .getElementById("check-form-data-register-save-draft")
                .click();
              // setSelectedOther([]);
            } else {
              setOpenModalComplete(false);
              setLoading(false);
            }
          } else {
            setLoading(false);
          }
        });
      }
      else {
        setValidateFields(true)
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error in handling form submission:", error);
    } finally {
      setLoading(false)
    }
  };

  const renderRequirmentScreen = (edit) => {
    return (
      <RequiredUploadDocuments
        isEdited={edit}
        objChangeMasterFile={objChangeMasterFile}
        financialInfo={financialInfo}
        setObjChangeMasterFile={setObjChangeMasterFile}
        setSelectedOther={setSelectedOther}
        selectedOther={selectedOther}
        setLoading={() => setLoading(false)}
        formView={null}
        formDisabled={true}
        validateFields={validateFields}
        isRequestValid={isRequestValid}
        defaultPerformanceBond={defaultPerformanceBond}
      />
    );
  };

  return (
    <>
      <Stack sx={{ width: "100%", margin: 5 }} spacing={4}>
        {/* steper */}
        <Stepper alternativeLabel connector={<ColorlibConnector />}>
          <Step>
            {!loading && (
              <Box display="flex" justifyContent="center" width="100%">
                <label style={{ fontWeight: "bold" }}>{companyName}</label>
              </Box>
            )}
            <br />
            <StepLabel StepIconComponent={ColorlibStepIcon}>
              Performance Bond Review
            </StepLabel>
          </Step>
        </Stepper>

        {/* body perf bond review */}
        <Box>{renderRequirmentScreen(isEdited)}</Box>

        {/* button-upload-submit */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {/* loading */}
          {loading && (
            <Backdrop sx={{ color: "#fff", zIndex: 2 }} open={true}>
              <span
                style={{
                  justifyContent: "center",
                  position: "fixed",
                  top: "40%",
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    m: 2,
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <CircularProgress
                    style={{
                      width: 100,
                      height: 100,
                      color: "rgba(184,0,200,1)",
                    }}
                  />
                </Box>
                <Box sx={{ justifyContent: "center", display: "flex" }}>
                  <label style={{ fontSize: 22, fontWeight: "bold" }}>
                    {" "}
                    Please wait...
                  </label>
                </Box>
              </span>
            </Backdrop>
          )}

          {/* cancel */}
          <Button
            sx={{ p: 1, m: 1 }}
            variant="outlined"
            onClick={() => {
              Swal.fire({
                title: "Do you want to leave this page?",
                icon: "question",
                position: "center",
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: "Yes",
              }).then((result) => {
                if (result.isConfirmed) {
                  navigate("/main");
                }
              });
            }}
            style={{
              backgroundColor: "#fff",
              color: "#757575",
              borderColor: "gray",
            }}
          >
            Cancel
          </Button>
          {/* submit */}
          {!isRequestValid &&
            <Button
              sx={{ p: 1, m: 1 }}
              variant="contained"
              disabled={loading}
              onClick={() => {
                handleSubmitFiles();
              }}
              style={{ backgroundColor: "#2C88D9", color: "white" }}
            >
              <label
                style={{ paddingLeft: 4, paddingRight: 4, cursor: "pointer" }}
              >
                Submit
              </label>
            </Button>
          }
        </Box>
      </Stack>

      <ModalPerformanceBondForm
        fromId={requestId}
        open={openModalComplete}
      // onHide={() => setOpenModalComplete(false)}
      />
    </>
  );
}
